import React from 'react';

import { EvTag, TAG_STATUS } from '@evinced-private/ui-common';

import ArrowGreenUpSmall from 'src/resources/icons/ArrowGreenUpSmall.svg?raw';
import ArrowRedDownSmall from 'src/resources/icons/ArrowRedDownSmall.svg?raw';

import './ScoreCellFormatter.scss';

interface IScoreData {
	value: number;
	percentage: number;
}

interface IScoreCellFormatterProps {
	scoreData: IScoreData;
}

export const ScoreCellFormatter: React.FC<IScoreCellFormatterProps> = ({ scoreData }) => {
	const { value, percentage } = scoreData;
	const isPositive = percentage >= 0;

	// For accessibility scores: positive percentage (score increase) = good = green arrow
	// negative percentage (score decrease) = bad = red arrow
	// Arrow direction should match the trend direction
	const icon = isPositive ? ArrowGreenUpSmall : ArrowRedDownSmall;
	const status: TAG_STATUS = isPositive ? TAG_STATUS.SUCCESS : TAG_STATUS.FAILURE;
	const text = `${isPositive ? '+' : ''}${percentage.toFixed(1)}%`;

	return (
		<div className="score-cell-formatter">
			<span className="score-value">{value}</span>
			<EvTag icon={icon} status={status} text={text} />
		</div>
	);
};
